export default __webpack_public_path__ + "static/banner-892e139f002db1632355ba085fad100d.jpg";